export default "__VITE_ASSET__BjT7xxSx__"